<script setup lang="ts">
defineProps<{
	src?: string
	alt?: string
	redirect?: string
	imgClass?: string
}>()
</script>

<template>
	<div :class="imgClass">
		<img
			:src="src"
			:alt="alt"
			class="cover cursor-pointer rounded bg-transparent px-4 py-2 hover:bg-white"
			@click="navigateTo(redirect, { external: true, open: { target: '_blank' } })"
		/>
	</div>
</template>
<style lang="css" scoped>
.cover {
	object-fit: cover;
	height: 100%;
	background-repeat: no-repeat;
	background-position: -100% 0;
	/*height: 300px;  optional, you can remove it, but in my case it was good */
}
</style>
